module.exports = __webpack_public_path__ + "img/event-swing-apero-teasing.aed7e1c.jpg";